import { Component, Input, OnInit } from "@angular/core";
import { map } from "rxjs";

import { UserSafeIPsService } from "src/app/core/api/services";
import { BaseSelectionList } from "../base/base-selection-list.component";

@Component({
    selector: "organization-confirmed-safeIp-selection-list",
    templateUrl: "./organization-confirmed-safeIp-selection-list.component.html",
    standalone: false
})
export class OrganizationConfirmedSafeIpListComponent
  extends BaseSelectionList
  implements OnInit
{
  @Input() organizationId: number;

  constructor(protected currentService: UserSafeIPsService) {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  initConfig() {
    this.optionValue = "ipAddress";
    this.optionTitle = "optionTitle";
    this.sortKey = "ipAddress";
  }

  getItems() {
    if (this.loading) return;
    this.loading = true;

    this.currentService
      .userSafeIPsGetOrganizationConfirmedSafeIp({
        body: { organizationId: this.organizationId },
      })
      .pipe(
        this.baseSelectionSearchPipeOperators,
        map((res) => {
          return res.data?.map((item) => {
            return {
              ...item,
              optionTitle: `${item.ipAddress} (${item.organizationName})`,
            };
          });
        })
      )
      .subscribe((items) => {
        this.items = items;
      });
  }
}
